import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center mb-l" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "mb-xxs sm:block lg:flex divide-y-2 lg:divide-y-0 divide-transparent" }
const _hoisted_4 = { class: "pb-s" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

import { computed, ref, watch, onMounted } from "vue";
import { useManagedPatientsStore } from "@/store/managedPatientsStore";
import { localeDateString } from "@/helpers/datehelper";
import UmanaHeadline from "@/components/UmanaHeadline.vue";
import ListTile from "@/components/ListTile.vue";
import DialogCard from "@/components/DialogCard.vue";
import UButton from "@/components/UButton.vue";
import router from "@/router";
import EmptyContainer from "@/components/EmptyContainer.vue";
import ProfileForm from "../components/ProfileForm.vue";
import { CareProviderGroup } from "@/interfaces/careProviderGroup";
import { usePublicStore } from "@/store/publicStore";
import { useSessionStore } from "@/store/sessionStore";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ManagedPatientsView',
  setup(__props) {

const managedPatientsStore = useManagedPatientsStore();
const sessionStore = useSessionStore();

onMounted(() => {
  const route = useRoute();
  patientSearch.value = route.query.patientSearch
    ? route.query.patientSearch.toString()
    : "";
  careProviderGroupFilter.value = connectedCareProviderGroups.value?.find(
    (cpg) => cpg.id == parseInt(route.query.cpg?.toString() ?? "nan")
  );
});
const publicStore = usePublicStore();

const managedPatients = computed(() =>
  Array.from(managedPatientsStore.patients?.values() ?? [])
);

const profileModel = ref<any>({});
const showModal = ref<boolean>(false);
const patientSearch = ref<string>("");
const careProviderGroupFilter = ref<CareProviderGroup | undefined>(undefined);

watch([careProviderGroupFilter, patientSearch], () => {
  router.replace({
    query: {
      cpg: careProviderGroupFilter.value?.id,
      patientSearch:
        patientSearch.value == "" ? undefined : patientSearch.value,
    },
  });
});

const connectedCareProviderGroups = computed(() => {
  if (managedPatientsStore.connectedCareProviderGroups) {
    let connectedCareProviderGroupIds = new Set<number>();
    managedPatientsStore.connectedCareProviderGroups.forEach((cpgs, p) => {
      connectedCareProviderGroupIds = new Set([
        ...cpgs,
        ...connectedCareProviderGroupIds,
      ]);
    });
    let cpgs: CareProviderGroup[] = [];
    connectedCareProviderGroupIds.forEach((cpgId) => {
      if (sessionStore.selectedCareProviderGroup?.id == cpgId) return;
      const cpg = publicStore.careProviderGroups?.find(
        (cpg) => cpg.id == cpgId
      );
      if (cpg) {
        cpgs.push(cpg);
      }
    });
    return cpgs;
  }
  return [];
});

const filteredManagedPatients = computed(() => {
  const searchWords = patientSearch.value.toLowerCase().split(/\s+/);

  const filteredPatients = managedPatients.value.filter((patient) => {
    const fullName = `${patient.currentProfile?.firstName} ${
      patient.currentProfile?.lastName
    } ${
      patient.currentProfile?.birthday
        ? localeDateString(patient.currentProfile?.birthday)
        : ""
    }`.toLowerCase();

    return (
      searchWords.every((word) => fullName.includes(word)) &&
      (!careProviderGroupFilter.value ||
        careProviderGroupFilter.value.id == undefined ||
        connectedCareProviderGroupsOfPatient(patient.id)?.has(
          careProviderGroupFilter.value.id
        ))
    );
  });

  filteredPatients.sort((a, b) => {
    if (a.currentProfile?.deceased && !b.currentProfile?.deceased) {
      return 1;
    }
    if (!a.currentProfile?.deceased && b.currentProfile?.deceased) {
      return -1;
    }
    if (
      (a.currentProfile?.lastName ?? "a").toLocaleLowerCase() <
      (b.currentProfile?.lastName ?? "a").toLocaleLowerCase()
    ) {
      return -1;
    } else if (
      (a.currentProfile?.lastName ?? "a").toLocaleLowerCase() >
      (b.currentProfile?.lastName ?? "a").toLocaleLowerCase()
    ) {
      return 1;
    } else {
      return 0;
    }
  });

  return filteredPatients;
});

async function createManagedPatient(model: any) {
  let cpg = model.cpg;
  model.cpg = undefined;
  await managedPatientsStore.createManagedPatient(model, cpg);
  profileModel.value = {};
  showModal.value = false;

  window._paq.push(["trackEvent", "CreateManagedPatient", "added", undefined]);
}

function bulkImport() {
  router.push("managedPatients/bulk");
}

function connectedCareProviderGroupsOfPatient(patientId: number) {
  if (managedPatientsStore.connectedCareProviderGroups) {
    return managedPatientsStore.connectedCareProviderGroups.get(patientId);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(UmanaHeadline, { h: "h1" }, {
        default: _withCtx(() => [
          _createTextVNode("Verwaltete Patienten")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(UButton, {
          onClick: bulkImport,
          class: "hidden md:flex"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Patienten importieren ")
          ]),
          _: 1
        }),
        _createVNode(UButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = true)),
          class: "ml-xs"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Patient hinzufügen ")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_FormKit, {
        type: "search",
        placeholder: "Textsuche",
        "outer-class": "!m-0 !mb-0",
        modelValue: patientSearch.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((patientSearch).value = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_FormKit, {
        type: "multiselect",
        placeholder: "Unternehmen filtern",
        "outer-class": "lg:!ml-xs lg:max-w-sm !mb-0",
        modelValue: careProviderGroupFilter.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((careProviderGroupFilter).value = $event)),
        "select-options": connectedCareProviderGroups.value,
        "track-by": "id",
        "option-label": "group_name",
        "allow-empty": false,
        reset: "Alle anzeigen"
      }, null, 8, ["modelValue", "select-options"])
    ]),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredManagedPatients.value, (managedPatient) => {
        return (_openBlock(), _createBlock(ListTile, {
          key: managedPatient.id,
          onClick: ($event: any) => (
          _ctx.$router.push({
            name: 'managedPatient',
            params: { id: managedPatient.id },
          })
        ),
          class: _normalizeClass(["px-xs", {
          '!text-gray-500': managedPatient.currentProfile?.deceased,
        }])
        }, {
          main: _withCtx(() => [
            (managedPatient.currentProfile?.deceased)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "† "))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(managedPatient.currentProfile?.firstName) + " " + _toDisplayString(managedPatient.currentProfile?.lastName) + " ", 1),
            (managedPatient.currentProfile)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(["♂", "♀"][managedPatient.currentProfile?.sex]), 1))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(managedPatient.currentProfile?.birthday
              ? `, ${_unref(localeDateString)(managedPatient.currentProfile?.birthday)}`
              : ""), 1)
          ]),
          _: 2
        }, 1032, ["onClick", "class"]))
      }), 128)),
      (filteredManagedPatients.value.length == 0)
        ? (_openBlock(), _createBlock(EmptyContainer, { key: 0 }, {
            default: _withCtx(() => [
              _createTextVNode(" Kein Patient gefunden ")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(DialogCard, {
      "show-footer": false,
      title: "Patient hinzufügen",
      "is-visible": showModal.value,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (showModal.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(ProfileForm, {
          "profile-model": profileModel.value,
          "on-save-profile": createManagedPatient,
          "select-cpg": true
        }, null, 8, ["profile-model"])
      ]),
      _: 1
    }, 8, ["is-visible"])
  ]))
}
}

})